import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BOARDS, DELETE_BOARDS } from 'manager/http-constants';
import { AuthorityDecision } from 'manager/user-authority-constant';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from 'src/app/shared/constant/api-constant';
import { CONSTANT } from 'src/app/shared/constant/constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import { DeleteDialogService } from 'src/app/shared/html-parts/confirm-dialog/delete-dialog/delete-dialog.service';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { Validator } from 'src/app/shared/validator/validator';
import { PlatformComponent } from '../../platform.component';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss', '../../platform.component.scss'],
})

/**
 * 共通部品_チャット
 */
export class ChatComponent extends PlatformComponent {
  // 画面.入力フォーム
  // チャットコメント
  chat_comment = new FormControl(CONSTANT.EMPTY_STRING, {
    asyncValidators: [
      this.validator.CheckValidator(
        'board',
        'board_comment',
        INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
      ),
    ],
  });

  // チャットコメントリスト格納先
  chatCommentList: any;

  // チャットコメントリスト毎秒取得キー
  timerId: any;

  // 呼び出しID
  pkeyId: string;

  // チャットモーダル表示フラグ
  chatModal: boolean = false;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private validator: Validator,
    private messageData: MessageData,
    private router: Router,
    public deleteDialogService: DeleteDialogService
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    // チャット取得を停止
    clearInterval(this.timerId);
  }

  /**
   * チャット機能初期処理
   * @param pkeyId 呼び出しID
   */
  public initial(pkeyId: string): void {
    // 既にチャットが開いているか否か
    if (this.chatModal) {
      // チャットが開いている場合

      // 処理を終了
      return;
    }

    // 呼び出しIDを格納
    this.pkeyId = pkeyId;

    // チャットコメントリスト取得
    this.getChatCommentList(true);

    // 30秒ごとに動作
    this.timerId = setInterval(() => {
      // チャットコメントリスト取得
      this.getChatCommentList();
    }, 30000);

    // チャットモダール表示
    this.chatModal = true;
  }

  /**
   * チャットコメントリスト取得
   * @param starting 起動回数 true:初回 false:2回目移行
   */
  public getChatCommentList(starting?: boolean): void {
    // 起動回数の判定
    if (starting) {
      // 初回起動の場合
      // 画面ロードフラグをON(ロード中状態)
      this.loadingState.loadStart(BOARDS);
    }

    // チャットコメントリストを取得
    this.dbOperationService
      .getNoTemplateData(BOARDS, {
        agenda_id: this.pkeyId,
      })
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // チャットコメントリストを格納
          this.chatCommentList = response.body;
        } else {
          this.chatCommentList = new Array();
        }

        // 起動回数の判定
        if (starting) {
          // 初回起動の場合
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, BOARDS);
        }
      });
  }

  /**
   * 送信
   */
  public send(): void {
    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: '',
        background_color: '',
        opacity: 0.3,
      }),
      BOARDS
    );

    // チャット登録を実施
    this.dbOperationService
      .insertData(BOARDS, {
        agenda_id: this.pkeyId,
        member_id: this.getLoginMemberId(),
        user_id: this.getLoginUserId(),
        board_comment: this.chat_comment.value,
      })
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, BOARDS);

        // レスポンス結果を判定
        if (API_RESPONSE.SUCCESS != response.body.Message) {
          // 異常終了の場合

          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00001),
              detail: this.commonService.msg(MESSAGE_CODE.E90003),
            })
          );
        }

        // チャット入力値を初期化
        this.chat_comment.reset();

        // チャットコメントリスト取得
        this.getChatCommentList();
      });
  }

  /**
   * 削除処理
   * @param boardId 掲示板コメントID
   */
  public delete(boardId: string): void {
    // 削除ダイアログにより削除処理
    this.deleteDialogService
      .deleteDialog(DELETE_BOARDS, '掲示板コメントID', boardId)
      .subscribe(() => {
        // チャットコメントリスト取得
        this.getChatCommentList();
      });
  }

  /**
   * 閉じるボタン
   */
  public close(): void {
    // チャット取得を停止
    clearInterval(this.timerId);

    // チャットモーダルを閉じる
    this.chatModal = false;
  }

  /**
   * 会員プロフィール(B211 or B212)へ遷移する
   */
  public moveB211orMoveB212(memberId: string, classId: string): void {
    // 自治体 or 事務局ユーザが否か
    if ('1' == classId || '9' == classId) {
      // 自治体 or 事務局ユーザの場合

      // 会員プロフィール(自治体)(B211)へ遷移
      this.router.navigate(['pages/platform/b211/' + memberId]);
    } else {
      //民間団体または関係省庁の場合

      // 会員プロフィール(民間団体)(B212)へ遷移
      this.router.navigate(['pages/platform/b212/' + memberId]);
    }
  }
}
